import {
  AtsGenerateJobPostingPreviewTokenDocument,
  AtsJobPostingStatusesEnum,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'

import { isJobOpen } from 'modules/ats/lib/utils/jobPosting'
import { useCompanyPageSettings } from 'modules/company_page/hooks/useCompanyPageSettings'

interface Props {
  id: string
  status: AtsJobPostingStatusesEnum
}

export const useJobPostingPreview = ({ id, status }: Props) => {
  const { buildUrl } = useCompanyPageSettings()

  const [preview] = useMutation(AtsGenerateJobPostingPreviewTokenDocument, {
    extractorFn: (data) => data.atsMutations.previewAtsJobPosting,
  })

  return async () => {
    const baseUrl = buildUrl(`/job_posting/${id}`)

    if (isJobOpen(status)) {
      return baseUrl
    }

    const result = await preview({
      variables: {
        id,
      },
    })

    const handled = handleResult(result, () => undefined)

    if (handled.success && handled.data?.jobPosting?.previewToken) {
      return `${baseUrl}?token=${handled.data.jobPosting.previewToken}`
    }

    return baseUrl
  }
}
